import Vue from "vue";
import store from "@/store";
import { http } from "@/helpers/http";
import VueRouter from "vue-router";

import Login from "../views/Login.vue";
import Register from "../views/Register.vue";

import SellerDashboard from "../views/Seller/Dashboard.vue";

import SellerShipper from "../views/Seller/Shippers.vue";

import SellerBill from "../views/Seller/Bills/index.vue";
import SellerBillList from "../views/Seller/Bills/List.vue";
import SellerBillCreate from "../views/Seller/Bills/Create.vue";
import SellerBillShow from "../views/Seller/Bills/Show.vue";

import SellerSettings from "../views/Seller/Settings/index.vue";
import SellerSettingsPricing from "../views/Seller/Settings/pricing.vue";
import SellerSettingsShipping from "../views/Seller/Settings/shipping.vue";
import SellerSettingsQr from "../views/Seller/Settings/qr.vue";
import SellerSettingsAccount from "../views/Seller/Settings/account.vue";

import SellerShipmentsReport from "../views/Seller/Reports/ShipmentsReport.vue";

import Test from "../views/Test.vue";
import PageNotFound from "../views/PageNotFound.vue";

Vue.use(VueRouter);

var routes = [
  {
    path: "/",
    name: "Seller-Home",
    meta: { layout: "seller" },
    component: SellerDashboard,
  },


  {
    path: "/login",
    name: "Login",
    meta: { layout: "auth" },
    component: Login,
  },

  {
    path: "/register",
    name: "Register",
    meta: { layout: "auth" },
    component: Register,
  },


  {
    path: "/seller/dashboard",
    name: "Seller-Dashboard",
    meta: { layout: "seller" },
    component: SellerDashboard,
  },

  // bills
  {
    path: "/seller/bills",
    meta: { layout: "seller" },
    component: SellerBill,
    children: [
      {
        path: "",
        name: "Seller-Bill-List",
        component: SellerBillList,
      },
      {
        path: "create",
        name: "Seller-Bill-Create",
        component: SellerBillCreate,
      },
      {
        path: ":billNo",
        name: "Seller-Bill-Show",
        component: SellerBillShow,
      }
    ],
  },

  // shippers
  {
    path: "/seller/shippers",
    meta: { layout: "seller" },
    name: "Seller-Shippers",
    component: SellerShipper
  },

  {
    path: "/seller/reports/shipments",
    name: "Reports-Shipments",
    meta: { layout: "seller" },
    component: SellerShipmentsReport,
  },

  {
    path: "/settings",
    meta: { layout: "seller" },
    component: SellerSettings,
    children: [
      {
        path: "",
        name: "Seller-Settings",
        component: SellerSettingsAccount,
      },
      {
        path: "account",
        name: "Seller-Settings-Account",
        component: SellerSettingsAccount,
      },
      {
        path: "pricing",
        name: "Seller-Settings-Pricing",
        component: SellerSettingsPricing,
      },
      {
        path: "shipping",
        name: "Seller-Settings-Shipping",
        component: SellerSettingsShipping,
      },
      {
        path: "checkout",
        name: "Seller-Settings-Qr",
        component: SellerSettingsQr,
      }
    ],
  },

  {
    path: "*",
    meta: { layout: "default" },
    name: "404",
    component: PageNotFound,
  },

];

const router = new VueRouter({
  routes,
});

// Auth Guard
router.beforeEach((to, from, next) => {
  // loadLanguageAsync("th").then(() => {
  if (needToCheckAuth(to.name)) {
    if (store.state.user.authData)
      http.defaults.headers.common["Authorization"] =
        "Bearer " + store.state.user.authData.token;
    else next({ name: "Login" });
  }
  next();
  // });
});

function needToCheckAuth(routeName) {
  console.log(routeName)
  // add other pathNames that doesn't require auth
  let except = ["Login", "Register", "Test"];
  return !except.includes(routeName);
}

export default router;
